import { ANONYMOUS_REPORT_MODULE_KEY } from '@deepguide-ai/types'
import { apiEndpoints } from './env'

/** Never use authenticated tRPC, cookies, browser storage or analytics here. */
export function anonymousReportApi(workspace: string) {
  const base = `${apiEndpoints.api}/anonymous-reports/${encodeURIComponent(workspace)}/${ANONYMOUS_REPORT_MODULE_KEY}`
  return async function request<T>(
    action: 'form' | 'submit' | 'files',
    body?: unknown
  ): Promise<T> {
    const response = await fetch(`${base}/${action}`, {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      cache: 'no-store',
      ...(body === undefined
        ? {}
        : {
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          }),
    })
    if (!response.ok)
      throw new Error(
        response.status === 404
          ? 'This reporting channel is unavailable.'
          : response.status === 429
            ? 'Please try again later.'
            : 'Unable to submit. Check your inputs and try again.'
      )
    return response.json() as Promise<T>
  }
}

export function anonymousReportUrl(workspaceId: string) {
  return `/workspaces/${encodeURIComponent(workspaceId)}/employee-center/whistleblower-report`
}
